import { render, staticRenderFns } from "./malfunction.vue?vue&type=template&id=28f3e092&scoped=true"
import script from "./malfunction.vue?vue&type=script&lang=js"
export * from "./malfunction.vue?vue&type=script&lang=js"
import style0 from "./malfunction.vue?vue&type=style&index=0&id=28f3e092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3e092",
  null
  
)

export default component.exports